import React, { useEffect, useMemo } from 'react';
import FlagColombia from '../CustomIcons/Flags/FlagColombia';
import ControlledNumberInput from '../Controlled/ControlledNumberInput';
import { Grid } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const schema = yup.object({
  phone: yup
    .string()
    .trim()
    .test(
      'optional-phone-length',
      'Debe tener 10 dígitos',
      value => !value || value.length === 10
    ),
  phoneCountryCode: yup
    .string()
    .trim()
    .max(3, 'Debe tener máximo 3 dígitos')
});

const PhoneWithCountryInput = props => {
  const {
    countryCode = '57',
    phoneNumber = '',
    loading = false,
    onValuesChange = null,
    required = false,
    classes = {}
  } = props;

  const defaultValues = useMemo(
    () => ({
      phoneCountryCode: countryCode || '57',
      phone: phoneNumber || ''
    }),
    [countryCode, phoneNumber]
  );

  const {
    control,
    errors,
    watch,
    reset,
    formState: { isValid }
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: 'all'
  });

  const phoneCountryCode = watch(
    'phoneCountryCode',
    defaultValues.phoneCountryCode
  );
  const phone = watch('phone', defaultValues.phone);

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  useEffect(() => {
    if (!onValuesChange) {
      return;
    }

    onValuesChange({
      phoneCountryCode,
      phone,
      isValid
    });
  }, [onValuesChange, phoneCountryCode, phone, isValid]);

  return (
    <>
      <Grid container justifyContent="flex-end" className={classes.root}>
        <Grid
          item
          xs={5}
          sm={5}
          container
          justifyContent="center"
          className={classes.countryCodeInput}
        >
          <ControlledNumberInput
            control={control}
            name={'phoneCountryCode'}
            id="PhoneValidation_form_input_phoneCountryCode"
            autoComplete="tel-country-code"
            required={required}
            InputProps={{
              startAdornment: (
                <FlagColombia size={20} style={{ flexShrink: 0 }} />
              )
            }}
            format="+###"
            placeholder="57"
            fullWidth
            label="Prefijo"
            disabled={loading}
            error={Boolean(errors.phoneCountryCode)}
            helperText={
              errors.phoneCountryCode && errors.phoneCountryCode.message
            }
            margin="none"
          />
        </Grid>
        <Grid item xs={7} sm={7} className={classes.phoneInput}>
          <ControlledNumberInput
            control={control}
            name={'phone'}
            id="PhoneValidation_form_input_phone"
            autoComplete="tel-local"
            required={required}
            fullWidth
            margin="none"
            label="Número celular"
            disabled={loading}
            error={Boolean(errors.phone)}
            helperText={errors.phone && errors.phone.message}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default PhoneWithCountryInput;
